const SMALL_MOBILE_SIZE_SCREEN = "smallMobile";
const MOBILE_SIZE_SCREEN = "mobile";
const TABLET_SIZE_SCREEN = "tablet";
const LAPTOP_SIZE_SCREEN = "laptop";
const DESKTOP_4K_SIZE_SCREEN = "desktop4k";
const LOADING = "loading";
const SUCCEEDED = "succeeded";
const FAILED = "failed";
const IDLE = "idle";
const PROJECT_FETCH_PROJECTS = "projects/fetchProjects";
const PROJECT_ADD_PROJECTS = "projects/addProject";
const PROJECT_EDIT_PROJECTS = "projects/editProject";
const PROJECT_TOGGLE_PROJECTS = "projects/toggleLike";
const IMAGES_FETCH_IMAGES_LIST_BY_ID = "images/fetchImageListById";
const FAILED_TO_FETCH_PROJECTS = "Failed to fetch projects";
const FAILED_TO_FETCH_IMAGES = "Failed to fetch images";
const FAILED_TO_ADD_PROJECT = "Failed to add project";
const FAILED_TO_EDIT_PROJECT = "Failed to edit project";
const UPLOAD_MODAL = "upload_modal";
const TYPE_UPLOAD_MODAL = "type_upload_modal";
const MANUAL_UPLOAD_MODAL = "manual_upload_modal";
const PREDATASET_UPLOAD_MODAL = "predataset_upload_modal";
const UPLOAD_VIDEO_MODAL = "upload_video_modal";
const VIEW_DETAILS_MODAL = "view_details_modal";
const VIEW_DETAILS = {
  name: "View Details",
  value: "viewDetails",
};
const RENAME = {
  name: "Rename",
  value: "rename",
};
const COPY_TO = {
  name: "Copy To",
  value: "copy_to",
};
const MOVE_TO = {
  name: "Move To",
  value: "move_to",
};
const DELETE = {
  name: "Delete",
  value: "delete",
};
const DOWNLOAD_THIS_DATA_SET = {
  name: "Download this data set",
  value: "downloadThisDataSet",
};

const colorSet = [
  { label: "Red", value: "#FF0000" },
  { label: "Light Salmon", value: "#FFA27F" },
  { label: "Bisque", value: "#ffe8c5" },
  { label: "Mantis", value: "#97BE5A" },
  { label: "Neon Carrot", value: "#FFA62F" },
  { label: "Grandis", value: "#FFC96F" },
  { label: "Feijoa", value: "#ACD793" },
  { label: "Blue Lagoon", value: "#006769" },
  { label: "Gossamer", value: "#40A578" },
  { label: "Canary", value: "#E6FF94" },
  { label: "Hot Pink", value: "#FF70AB" },
  { label: "Iris Blue", value: "#03AED2" },
  { label: "Remy", value: "#F5DAD2" },
  { label: "Maya Blue", value: "#5AB2FF" },
  { label: "Jewel", value: "#0A6847" },
  { label: "Tumbleweed", value: "#DBA979" },
  { label: "Sea Buckthorn", value: "#ED9455" },
  { label: "Zuccini", value: "#114232" },
  { label: "Venetian Red", value: "#C51605" },
  { label: "Caribbean Green", value: "#00DFA2" },
  { label: "Razzmatazz", value: "#FF0060" },
  { label: "Medium Orchid", value: "#A459D1" },
  { label: "Alizarin", value: "#DF2E38" },
  { label: "Paris Daisy", value: "#F0FF42" },
  { label: "Pohutukawa", value: "#470D21" },
  { label: "Jazzberry Jam", value: "#9C0F48" },
  { label: "Light Green", value: "#8DECB4" },
  { label: "Medium Sea Green", value: "#41B06E" },
  { label: "Persian Indigo", value: "#49108B" },
  { label: "Tyrian Purple", value: "#3E001F" },
  { label: "Electric Indigo", value: "#5800FF" },
];

export {
  SMALL_MOBILE_SIZE_SCREEN,
  MOBILE_SIZE_SCREEN,
  TABLET_SIZE_SCREEN,
  LAPTOP_SIZE_SCREEN,
  DESKTOP_4K_SIZE_SCREEN,
  LOADING,
  SUCCEEDED,
  FAILED,
  IDLE,
  PROJECT_FETCH_PROJECTS,
  PROJECT_ADD_PROJECTS,
  PROJECT_EDIT_PROJECTS,
  PROJECT_TOGGLE_PROJECTS,
  FAILED_TO_FETCH_PROJECTS,
  FAILED_TO_ADD_PROJECT,
  FAILED_TO_EDIT_PROJECT,
  UPLOAD_MODAL,
  TYPE_UPLOAD_MODAL,
  MANUAL_UPLOAD_MODAL,
  PREDATASET_UPLOAD_MODAL,
  UPLOAD_VIDEO_MODAL,
  VIEW_DETAILS,
  RENAME,
  COPY_TO,
  MOVE_TO,
  DELETE,
  DOWNLOAD_THIS_DATA_SET,
  VIEW_DETAILS_MODAL,
  FAILED_TO_FETCH_IMAGES,
  IMAGES_FETCH_IMAGES_LIST_BY_ID,
  colorSet,
};
